/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ListMyCompaniesQueryResponse,
  ListMyCompaniesQueryParams,
} from '../types/ListMyCompanies'

function getListMyCompaniesUrl() {
  const res = {
    method: 'GET',
    url: `/api/v1/common/search/chains_my/` as const,
  }
  return res
}

/**
 * @description Handle GET request for search.
 * This is the main entry point that orchestrates the search process.
 * @summary List the authenticated user's custom (unmatched) companies
 * {@link /api/v1/common/search/chains_my/}
 */
export async function listMyCompanies(
  params?: ListMyCompaniesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ListMyCompaniesQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getListMyCompaniesUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
